import {
  ScrollDirection,
  useScrollWithShadow,
} from "~/hooks/useScrollWithShadow";
import { useRect } from "~/hooks/useRect";

import "./ScrollContainer.css";

import type { ReactNode } from "react";

const SCROLL_CONTAINER_MARGIN = 5;

export interface ScrollContainerProps {
  scrollDirection?: ScrollDirection;
  children?: ReactNode;
  width?: string;
  height?: string;
}

export function ScrollContainer({
  scrollDirection,
  children,
  height,
  width,
}: ScrollContainerProps) {
  const [containerRef, DOMRect] = useRect<HTMLDivElement>();

  const [ref, { boxShadow, onScroll }] = useScrollWithShadow<HTMLDivElement>({
    scrollDirection: scrollDirection ?? ScrollDirection.Horizontal,
    margin: SCROLL_CONTAINER_MARGIN,
    containerRect: DOMRect,
  });

  return (
    <div
      ref={containerRef}
      className="ScrollContainer"
      data-direction={scrollDirection}
      style={{ height, width }}
    >
      <div
        ref={ref}
        className="ScrollContainer__content"
        onTouchMove={onScroll}
        onWheel={onScroll}
      >
        {children}
      </div>
      <div className="ScrollContainer__shadow" style={{ boxShadow }}></div>
    </div>
  );
}
